import Request from './request'
import i18n from '@/i18n'
import store from '@/store.js'
import snackbar from '@/plugins/snackbar'
// 批次管理
async function fetch(data){
    return Request("get","api/stock-details/",data)
}

async function fetchOne(id){
    return Request("get","api/stock-details/" + id)
}

// 冻结
async function prohibit(id){
    return Request("get","api/stock-details/prohibit/" + id)
}
// 解冻
async function unProhibit(id){
    return Request("get","api/stock-details/un-prohibit/" + id)
}
// 报损
async function loss(id){
    return Request("get","api/stock-details/loss/" + id)
}

async function fetchByPositionMaterial(data){
  return Request("get" , "api/stock-details/view-by-position-material",data)
}

async function getPositionStockDetails(data){
    return Request("get" , "api/stock-details/get-position-stock-details",data)
}

//保存编辑
async function save(data) {
  return Request("post" , "api/stock-details/edit", data)
}

// 导出一览
async function exports(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-details/export', data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

// 库位批次导出
async function positionExport(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-details/position-export', data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

// 导出明细
async function stockDetailExport(id) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/stock-details/stock-details-export?id=' + id)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

// 打印明细
async function stockDetailPrint(id) {
    return Request('get','api/stock-details/stock-details-print/'+id)
}

async function qualifyReportEdit(data) {
    return Request("post" , "api/stockDetails/qualifyReportEdit", data)
  }
  
export default {
    fetch,
    fetchOne,
    prohibit,
    unProhibit,
    loss,
    fetchByPositionMaterial,
    getPositionStockDetails,
    save,
    exports,
    stockDetailExport,
    stockDetailPrint,
    qualifyReportEdit,
    positionExport,
}